import { useTranslation } from "react-i18next";
import { ao3ScreenshotImages } from "@/mocks/ao3Home";
import Ao3Reveal from "./Ao3Reveal";

export default function Ao3Screenshots() {
  const { t } = useTranslation();

  return (
    <section id="ao3-screenshots" className="w-full bg-background-100 border-y border-background-200/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <Ao3Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 dark:text-primary-400">{t("screenshots.badge")}</span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">{t("screenshots.title")}</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{t("screenshots.subtitle")}</p>
        </Ao3Reveal>

        <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 md:mt-14 md:gap-x-5 lg:grid-cols-5">
          {ao3ScreenshotImages.map((shot, index) => (
            <Ao3Reveal key={shot.id} delay={index * 90}>
              <figure className="flex flex-col items-center gap-4">
                <div className="w-full max-w-[240px] rounded-[2rem] border border-background-300/70 bg-background-50 p-2">
                  <div className="flex w-full items-center justify-center overflow-hidden rounded-[1.6rem] bg-background-200">
                    <img
                      src={shot.image}
                      alt={`${t(`screenshots.items.${shot.id}`)} screen`}
                      title={`AO3 Reader ${t(`screenshots.items.${shot.id}`)}`}
                      className="block h-auto w-full object-contain object-top"
                    />
                  </div>
                </div>
                <figcaption className="text-center text-sm font-medium text-foreground-700">{t(`screenshots.items.${shot.id}`)}</figcaption>
              </figure>
            </Ao3Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}